import { render } from "./CheckinButtonAndModalComponent.vue?vue&type=template&id=0a1d8e93"
import script from "./CheckinButtonAndModalComponent.vue?vue&type=script&lang=js"
export * from "./CheckinButtonAndModalComponent.vue?vue&type=script&lang=js"
script.render = render

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
